import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import validator from 'validator';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;
        const {
            companyId='', inhouz_reserved_parameters_xyzh={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(
            appEnvironment !== 'production'
        ){
            variableObject[variableName] = {
                error : {
                    message : 'This function only runs in a production environment.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'This function only runs in a production environment.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        let variableCopy = parsedParameters['variableObject'];
        if(parsedParameters.error){
            variableCopy[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];
        let payload = {
            userId : resolvedParams['userId'] || '',
            email : resolvedParams['email'] || '',
            companyId,
            terminationType : 'cancel license',
            terminationNotes : resolvedParams['terminationNotes'] || ''
        }

        if(
            !validator.isEmail(payload['email'])
        ){
            variableCopy[variableName] = {
                error : {
                    message : 'Invalid Email.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Invalid Email.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!validator.isMongoId(payload['userId'])){
            variableCopy[variableName] = {
                error : {
                    message : 'Invalid user ID.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Invalid user ID.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            !payload['companyId'] ||
            (typeof payload['companyId'] !== 'string')
        ){
            variableCopy[variableName] = {
                error : {
                    message : 'Account ID is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Account ID is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['X-API-KEY']){
            variableCopy[variableName] = {
                error : {
                    message : 'API key is missing.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'API key is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let clientEncryptedApiHeader = encryptDecrypt(
            JSON.stringify({
                payload : {
                    'X-API-KEY' : resolvedParams['X-API-KEY'],
                    companyId,
                    queryKey : `${Math.random()}${Math.random()}${Math.random()}${new Date().getTime()}`,
                    environment : appEnvironment
                },
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let encryptedPayload = encryptDecrypt(
            JSON.stringify({
                payload,
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let response = await fetch(
            `${config.devServerProxy}/api/accounttermination/useraccounttermination`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache',
                    'X-CE-API-KEY' : clientEncryptedApiHeader
                },
                credentials : 'omit',
                body : JSON.stringify({
                    encryptedPayload,
                    functionGenerated : true
                })
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/cancelInhouzCloudUserParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}